import { render, staticRenderFns } from "./OpenOpportunitiesBySalesperson.vue?vue&type=template&id=38a03a0e&"
import script from "./OpenOpportunitiesBySalesperson.vue?vue&type=script&lang=js&"
export * from "./OpenOpportunitiesBySalesperson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports